export function isOptionGroup(option) {
  return option.options !== undefined;
}